/* global window */

import Vue from 'vue';

import './TestContact.scss';
import template from './TestContact.vhtml';

const imageUrl = url => `url( '${url}' )`;

export default {
	name: 'TestContact',
	template: template,
	props: {
		portrait: {
			type: String,
		},
		headline: {
			type: String,
		},
		text: {
			type: String,
		},
		phone: {
			type: String,
		},
		email: {
			type: String,
		},
		facebook1: {
			type: Object,
		},
		facebook2: {
			type: Object,
		},
	},
	methods: {
		imageUrl: imageUrl,
		openContactSlider() {
			//this.$emit('open-contact-slider');
			window.siteData.isContactFormOpen = true;
		}
	},
};
